var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedlinemiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.4 17.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #d31b20;\n        stroke-miterlimit: 10;\n        stroke-width: .56px;\n      }\n\n      .cls-2 {\n        stroke-dasharray: 0 0 1.6 1.6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0,
    y1: 17.29,
    x2: 0.8,
    y2: 17.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.4,
    y1: 17.29,
    x2: 145.8,
    y2: 17.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.6,
    y1: 17.29,
    x2: 147.4,
    y2: 17.29
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 0.28,
    x2: 0.8,
    y2: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.4,
    y1: 0.28,
    x2: 145.8,
    y2: 0.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 146.6,
    y1: 0.28,
    x2: 147.4,
    y2: 0.28
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedlinemiddle);
export default __webpack_public_path__ + "static/media/redlinemiddle.8223fbea215604c01c95bff266c4d54d.svg";
export { ForwardRef as ReactComponent };